import { SimplifiedUserRole } from '@platform/client/schemas';
import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';

type MatchConfirmedContentProps = {
  userAccountType: SimplifiedUserRole;
  otherPartyName: string;
};

export const MatchConfirmedContent = (props: MatchConfirmedContentProps) => {
  const { userAccountType, otherPartyName } = { ...props };
  return (
    <div className='flex flex-col md:flex-row md:items-center gap-4 md:gap-0 items-center justify-center md:justify-around h-full'>
      <div className='hidden md:flex w-1/2 items-center justify-center'>
        <GreenCircleCheckmark size={350} />
      </div>
      <div className='flex md:hidden items-center justify-center'>
        <GreenCircleCheckmark size={125} />
      </div>
      <div className='flex flex-col gap-8 md:w-1/2 text-center md:text-left'>
        <div className='text-xl font-semibold min-w-[288px] md:w-[568px]'>
          {userAccountType === SimplifiedUserRole.PROFESSIONAL ?
            'Your match is confirmed!'
          : 'Thanks for confirming!'}
        </div>
        <div className='text-lg min-w-[288px] md:w-[500px]'>
          {userAccountType === SimplifiedUserRole.PROFESSIONAL ?
            `We'll introduce you to ${otherPartyName} by email. Go to your Project Hub to prepare for your Planning Call.`
          : `Your side is confirmed. We've let the professional know and will update you once they confirm too.`
          }
        </div>
      </div>
    </div>
  );
};
